import React from 'react';
import Box from '@material-ui/core/Box';

import Typography from '@material-ui/core/Typography';
import UserIcon from '@material-ui/icons/Group';

import { CreateButton } from 'react-admin';

const UserEmpty = ({ basePath, resource }) => (
  <Box textAlign="center" m={1}>
    <UserIcon style={{ fontSize: 140 }} />
    <Typography variant="h4" paragraph>
      No users available yet.
    </Typography>
    <Typography variant="body1">Do you want to add one?</Typography>
    <CreateButton className="primary" basePath={basePath} />
  </Box>
);

export default UserEmpty;
